import { render, staticRenderFns } from "./RiskReview.vue?vue&type=template&id=c20d150a&"
import script from "./RiskReview.vue?vue&type=script&lang=js&"
export * from "./RiskReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports